import { store } from 'redux/store';
import { apiInterceptor } from 'utils/apiInterceptor';

export async function getSpeakerImportLogById(projectId, id) {
    const user = store?.getState()?.user;

    if (user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/import-logs/${id}/${projectId}`,
            {
                method: 'GET',
            }
        );

        return await response.json();
    }
}
